
    <div class="container">
        <div class="row mb-4 mt-4">
            <div class="col-12 mb-3 mb-lg-5">
                <a [routerLink]="['/','admin', 'tours-update', idViaje]" class="mb-4 d-flex flex-row align-items-center text-decoration-none">
                    <img src="../assets/images/body/icons/volver.svg" class="pe-2" alt="">
                    <h4 class="text-primary mb-0"> Volver</h4>
                </a>
            </div>
            
            <div class="col-lg-8 col-xxl-8 col-4 z-index--top">
                <h3 class="mb-2">Itinerario</h3>  
            </div>
            <div class="col-lg-4 col-xxl-4 col-8 z-index--top d-flex justify-content-md-end justify-content-center">
                                   
                
            </div>
            
        </div>
        <div class="row">
            <div class="col-12">
                <form [formGroup]="form2" class="login">
                    <div formArrayName="actividades">
                        <div [formGroupName]="i" *ngFor="let actividad of actividades.controls; let i = index;" 
                            class="row mb-5 bg-grey br-30-10 py-4 px-4 shadow-sm">  
                                <div class="col-12 col-md-4 mb-3">
                                    <h3 class="text-secondary">Día</h3>
                                    <div class="pt-2">
                                        <input type="text" class="w-100" formControlName="dia" value="Primer Día">
                                    </div>  
                                    <div *ngIf="submitted && form2.controls['actividades'].controls[i].controls['dia'].errors" class="text-danger">
                                        <div *ngIf="form2.controls['actividades'].controls[i].controls['dia'].errors.required">Día es requerido.</div>
                                    </div>      
                                </div>           
                                <div class="col-12 col-md-8">
                                    <h3 class="text-secondary">Descripción</h3>
                                    <div class="pt-2">
                                        <textarea type="text" formControlName="descripcion" class="w-100 h-auto"></textarea>
                                    </div>    
                                    <div *ngIf="submitted && form2.controls['actividades'].controls[i].controls['descripcion'].errors" class="text-danger">
                                        <div *ngIf="form2.controls['actividades'].controls[i].controls['descripcion'].errors.required">Descripción es requerido.</div>
                                    </div>                
                                </div>                            
                        </div>
                    </div>
                    <div class="row mb-5">
                        <div class="col-12 col-md-12 text-end">
                            <button style="cursor: pointer;"  type="button" *ngIf="actividades.length"(click)="delete(actividades.length)" class="lh-1 btn btn-lg btn-primary rounded-pill text-center btn-reservar align-self-center mt-lg-0 mt-4">Eliminar día <img style="height: 30px; width: 30px;" src="../assets/images/body/icons/minus.svg" class="ps-2" alt=""></button>
                            <button style="cursor: pointer;"  type="button" (click)="add()" class="lh-1 btn btn-lg btn-primary rounded-pill text-center btn-reservar align-self-center mt-lg-0 mt-4" style="margin-left: 18px;">Agregar día <img style="height: 30px; width: 30px;" src="../assets/images/body/icons/plus.svg" class="ps-2" alt=""></button>    
                        </div>
                    </div>
                </form>
            </div>
            <hr class="mb-5">
        </div>
        <div class="row"> 
            <div class="col-lg-12 col-xxl-12 z-index--top">
                <h3 class="mb-4">Imágenes de slider</h3>               
            </div>
            <form [formGroup]="form" class="login">
            <!--<div class="align-items-center align-items-md-baseline col-12 col-md-12 d-flex flex-column flex-md-row mb-5 mt-3">-->
                <input *ngIf="!showInputItinerario" type="file" id="loadImagenItinerario" name="imagenesItinerario" style="display:none" multiple
                      accept="image/jpeg, image/jpg, image/png" (change)="fileEvent($event)"/>
                <input *ngIf="showInputItinerario" type="file" id="loadImagenItinerario" name="imagenesItinerario" style="display:none" multiple
                      accept="image/jpeg, image/jpg, image/png" (change)="fileEvent($event)"/>
                <div *ngIf="!imagenesItinerario.length" class="align-items-center align-items-md-baseline col-12 col-md-12 d-flex flex-column flex-md-row mb-5 mt-3">
                        <div class="d-flex img-tour justify-content-end align-items-center flex-column radius-10" style="float: left">
                            <img src="../assets/images/body/tours/01.jpg" class="h-100" alt="">                        
                        </div>
                        <div class="d-flex img-tour justify-content-end align-items-center flex-column radius-10" style="float: left">
                            <img src="../assets/images/body/tours/01.jpg" class="h-100" alt="">                        
                        </div>
                        <div class="d-flex img-tour justify-content-end align-items-center flex-column radius-10" style="float: left">
                            <img src="../assets/images/body/tours/01.jpg" class="h-100" alt="">                        
                        </div>  
                        <label for="loadImagenItinerario" class="btn btn-lg btn-primary rounded-pill text-center btn-reservar align-self-center mt-lg-0 mt-4">Cargar imagen</label>
                </div>                 
                <div *ngIf="imagenesItinerario.length" class="align-items-center align-items-md-baseline col-12 col-md-12 d-flex flex-column flex-md-row mb-5 mt-3">
                        
                        <div formArrayName="imagenesItinerario" *ngFor="let imagenesItinerario of imagenesItinerario.controls; let i = index;" >
                            <div class="d-flex img-tour justify-content-end align-items-center flex-column radius-10" style="float: left">
                                <div [formGroupName]="i">
                                    <img [src]="imagenesItinerario.controls.url.value" class="w-100" alt="Image Preview">                               
                                </div>
                                <button style="cursor: pointer;"  type="button" class="btn btn-danger position-absolute w-100" (click)="deleteItem(i)">Eliminar</button>
                            
                            </div>
                            <div  [ngClass]="{'text-danger':imagenesItinerario.controls.toBig && imagenesItinerario.controls.toBig.value == true, 'text-normal':imagenesItinerario.controls.toBig && imagenesItinerario.controls.toBig.value == false}">
                                La imagen excede los 2MB                     
                            </div>
                       </div>
                        <label for="loadImagenItinerario" class="btn btn-lg btn-primary rounded-pill text-center btn-reservar align-self-center mt-lg-0 mt-4">Cargar imagen</label>
                </div>                                 
            <!--</div>-->
            <div *ngIf="submitted && form.controls.imagenesItinerario.errors " class="text-danger">
                <div *ngIf="form.controls.imagenesItinerario.errors.required" style="padding-left: 18px; margin-top: -80px;">Imagen es requerida.</div>
            </div>
            </form>
        </div>
        
        <div class="row"> 
            <div class="col-lg-12 col-xxl-12 z-index--top mt-3">
                <h3 class="mb-4">Excursiones opcionales</h3>               
            </div>

            <div class="align-items-center align-items-md-baseline col-12 col-md-12 d-flex flex-column flex-md-row mb-5 mt-3">
                <form [formGroup]="form3" class="login w-100">
                    <div class="row mb-5 bg-grey br-30-10 py-4 px-4 shadow-sm">
                        <h5 class="text-secondary mb-3">Excursión</h5>
                        <div formArrayName="excursiones">
                            <div [formGroupName]="i" *ngFor="let excursion of excursiones.controls; let i = index;">
                                <div class="col-12 col-md-12 d-flex flex-row mb-3">
                                    <img src="../assets/images/body/tours/salida.svg" class="pe-3" alt="">
                                    <input type="text" formControlName="nombre" class="w-100" placeholder="Ingrese aquí el nombre de la excursión">
                                </div> 
                                <div *ngIf="submitted && form3.controls['excursiones'].controls[i].controls['nombre'].errors" class="text-danger" style="padding-left: 80px;">
                                    <div *ngIf="form3.controls['excursiones'].controls[i].controls['nombre'].errors.required">Nombre de excursión es requerido.</div>
                                </div>  
                            </div>                            
                        </div>  
                        <div class="col-12 col-md-12 text-end mt-3">
                            <button style="cursor: pointer;"  type="button" *ngIf="excursiones.length" (click)="deleteExcursion(excursiones.length)" class="lh-1 btn btn-lg btn-primary rounded-pill text-center btn-reservar align-self-center mt-lg-0 mt-4">Eliminar excursiones <img style="height: 30px; width: 30px;" src="../assets/images/body/icons/minus.svg" class="ps-2" alt=""></button>
                            <button style="cursor: pointer;"  type="button" (click)="addExcursion()" class="lh-1 btn btn-lg btn-primary rounded-pill text-center btn-reservar align-self-center mt-lg-0 mt-4" style="margin-left: 18px;">Agregar excursiones <img style="height: 30px; width: 30px;" src="../assets/images/body/icons/plus.svg" class="ps-2" alt=""></button> 
                        </div>         
                    </div>
                </form>                 
            </div>
        </div>

        <div class="row"> 
            <div class="col-lg-12 col-xxl-12 z-index--top">
                <h3 class="mb-4">Imágenes de slider</h3>               
            </div>
            <form [formGroup]="form1" class="login">
            <!--<div class="align-items-center align-items-md-baseline col-12 col-md-12 d-flex flex-column flex-md-row mb-5 mt-3">-->
                <input *ngIf="!showInputExcursiones" type="file" id="loadImagenExcursion" name="imagenesExcursion" style="display:none" multiple
                      accept="image/jpeg, image/jpg, image/png" (change)="fileEvent1($event)"/>
                <input *ngIf="showInputExcursiones" type="file" id="loadImagenExcursion" name="imagenesExcursion" style="display:none" multiple
                      accept="image/jpeg, image/jpg, image/png" (change)="fileEvent1($event)"/>
                <div *ngIf="!imagenesExcursion.length" class="align-items-center align-items-md-baseline col-12 col-md-12 d-flex flex-column flex-md-row mb-5 mt-3">
                    <div class="d-flex img-tour justify-content-end align-items-center flex-column radius-10" style="float: left">
                        <img src="../assets/images/body/tours/01.jpg" class="h-100" alt="">                    
                    </div>
                    <div class="d-flex img-tour justify-content-end align-items-center flex-column radius-10" style="float: left">
                        <img src="../assets/images/body/tours/01.jpg" class="h-100" alt="">
                    </div>
                    <div class="d-flex img-tour justify-content-end align-items-center flex-column radius-10" style="float: left">
                        <img src="../assets/images/body/tours/01.jpg" class="h-100" alt="">
                    </div>
                    <label for="loadImagenExcursion" class="btn btn-lg btn-primary rounded-pill text-center btn-reservar align-self-center mt-lg-0 mt-4">Cargar imagen</label>
                </div>  
                          
                <div *ngIf="imagenesExcursion.length" class="align-items-center align-items-md-baseline col-12 col-md-12 d-flex flex-column flex-md-row mb-5 mt-3">
                    <div formArrayName="imagenesExcursion" *ngFor="let imagenesExcursion of imagenesExcursion.controls; let i = index;" >
                        <div class="d-flex img-tour justify-content-end align-items-center flex-column radius-10" style="float: left">
                            <div [formGroupName]="i">
                                <img [src]="imagenesExcursion.controls.url.value" class="w-100" alt="Image Preview">                               
                            </div>
                            <button style="cursor: pointer;"  type="button" class="btn btn-danger position-absolute w-100" (click)="deleteItemExcursion(i)">Eliminar</button>
                        
                        </div>
                        <div  [ngClass]="{'text-danger':imagenesExcursion.controls.toBig && imagenesExcursion.controls.toBig.value == true, 'text-normal':imagenesExcursion.controls.toBig && imagenesExcursion.controls.toBig.value == false}">
                            La imagen excede los 2MB                     
                        </div>
                   </div>
                    <label for="loadImagenExcursion" class="btn btn-lg btn-primary rounded-pill text-center btn-reservar align-self-center mt-lg-0 mt-4">Cargar imagen</label>
                </div>                                     
            <!--</div>-->
            <div *ngIf="submitted && form1.controls.imagenesExcursion.errors " class="text-danger">
                <div *ngIf="form1.controls.imagenesExcursion.errors.required" style="padding-left: 18px; margin-top: -80px;">Imagen es requerida.</div>
            </div>
            </form>
        </div>

        <div class="row"> 
            <div class="col-lg-12 col-xxl-12 z-index--top mt-3">
                <h5 class="align-items-center bg-primary d-flex text-white title-bg shadow">Observaciones / Información adicional</h5>
                <h3 class="mt-4 text-secondary">Título</h3>               
            </div>

            <form [formGroup]="form4" class="login w-100">

                <div class="row mb-5">
                    
                    <div class="col-12 col-md-12 d-flex flex-row mb-3">
                        <input type="text" formControlName="titulo" class="w-100"  placeholder="Ingrese aquí el nombre de la excursión">                                
                    </div>           
                    <div class="col-12 col-md-12 d-flex flex-row mb-3">
                        <textarea type="text" formControlName="texto" class="w-100"  placeholder="Ingrese aquí las observaciones y/o información adicional"></textarea>      
                    </div>           
                           
                </div>
                <div class="col-12 text-center z-index--top">
                    <button style="cursor: pointer;"  type="button" (click)="salvar()" class="btn btn-lg rounded-pill btn-primary text-white text-center align-self-center z-index--top ">Guardar Cambios</button> 
                </div>
            </form>  
            
        </div>


    </div>



